function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFAF20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.958 38.857c-2.438 0-4.416 2.048-4.416 4.572 0 2.523 1.978 4.571 4.416 4.571 2.439 0 4.417-2.048 4.417-4.571 0-2.524-1.978-4.572-4.417-4.572zm0 2.286c1.219 0 2.209 1.024 2.209 2.286 0 1.261-.99 2.285-2.209 2.285-1.218 0-2.208-1.024-2.208-2.285 0-1.262.99-2.286 2.208-2.286zM17.667 38.857c-2.439 0-4.417 2.048-4.417 4.572 0 2.523 1.978 4.571 4.417 4.571 2.438 0 4.416-2.048 4.416-4.571 0-2.524-1.978-4.572-4.416-4.572zm0 2.286c1.218 0 2.208 1.024 2.208 2.286 0 1.261-.99 2.285-2.208 2.285-1.219 0-2.209-1.024-2.209-2.285 0-1.262.99-2.286 2.209-2.286z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.833 0c.449 0 .845.28 1.016.695l.06.186 8.63 37.976h23.42c.541 0 .992.404 1.086.938l.017.205c0 .561-.39 1.028-.905 1.124l-.199.019H17.667c-.449 0-.845-.28-1.016-.695l-.06-.186L7.96 2.286H1.104c-.542 0-.993-.405-1.086-.938L0 1.143C0 .582.39.115.906.018L1.104 0h7.73z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.896 13.714c.691 0 1.196.642 1.092 1.32l-.044.185-6.625 20.571c-.129.4-.457.688-.848.763l-.2.018H16.627c-.61 0-1.104-.511-1.104-1.142 0-.561.39-1.028.906-1.125l.198-.018h27.847L50.36 16H11.952c-.542 0-.993-.404-1.086-.937l-.018-.206c0-.56.39-1.028.906-1.124l.198-.019h39.944z"
}));

var SvgGroceriesTransactionsIcon = function SvgGroceriesTransactionsIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 48,
    style: {
      background: "transparent"
    },
    viewBox: "0 0 53 48",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroceriesTransactionsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/groceries_transactions_icon.89b7cae9.svg";
export { ForwardRef as ReactComponent };